import React from 'react';

interface ToolkitPanelProps {
  visible: boolean;
  onHide: () => void;
  children: React.ReactNode;
}

export const ToolkitPanel = ({ visible, onHide, children }: ToolkitPanelProps) => {
  if (!visible) return null;

  return (
    <div className="bg-theme-white absolute inset-4 z-50 flex flex-col overflow-hidden rounded-2xl shadow-lg">
      <div className="flex shrink-0 cursor-default items-center justify-between rounded-t-2xl border-t-0 py-6 pr-6 pl-6">
        <h2 className="text-theme-black flex-1 text-center text-2xl leading-8 font-semibold">
          Choose a prompt from our well-crafted toolkit
        </h2>
        <button
          onClick={onHide}
          className="hover:bg-fletchers-green-50 focus-visible:outline-fletchers-green-500 text-theme-black relative ml-2 flex size-8 cursor-pointer items-center justify-center overflow-hidden rounded-full border-0 bg-transparent outline-transparent transition duration-200 ease-in-out hover:border-transparent focus-visible:outline-2"
          aria-label="Close"
        >
          <i className="pi pi-times inline-block size-4" />
        </button>
      </div>

      <div className="bg-theme-white @container flex-1 overflow-y-auto rounded-b-2xl px-6 pt-0 pb-0">{children}</div>
    </div>
  );
};
